import { SumarDiasFecha } from "./DatesFunctions";

export const KEY_SHOWMODALACTUALIZAR_DATOSPERSONALES: string = "SoloContinuoModal";
export const KEY_EXPIRE_MODALACTUALIZARDATOSPERSONALES: string = "Expires-SoloContinuoModal"

export const KEY_SHOWMODAL_MARCACION_AVISO: string = "modalMarcacionAviso";
export const KEY_EXPIRE_MODAL_MARCACION_AVISO: string = "Expires-modalMarcacionAviso";




const ARRAY_LOCALSTORAGE_MODALACTUALIZARDP = [KEY_SHOWMODALACTUALIZAR_DATOSPERSONALES, KEY_EXPIRE_MODALACTUALIZARDATOSPERSONALES]
const ARRAY_LOCALSTORAGE_MODALMARCACIONES= [KEY_SHOWMODAL_MARCACION_AVISO, KEY_EXPIRE_MODAL_MARCACION_AVISO]


export function AddLocalStorageElements(keyslocalstorage: Array<string>) {

    for (let index = 0; index < keyslocalstorage.length; index++) {
        var nombreStorage = keyslocalstorage[index];
        localStorage.removeItem(nombreStorage);
    }
}

export function AddLocalStorageElement(name: string, value: string) {
    localStorage.setItem(name, value);
}

export function VerifyShowMensajeMarcacionStorage() {
    const storedData = localStorage.getItem(KEY_SHOWMODAL_MARCACION_AVISO);
    const storedDataDate = localStorage.getItem(KEY_EXPIRE_MODAL_MARCACION_AVISO);




    if (storedData !== null && storedData === "false") {
        return true;
    }
    else if (storedData !== null && storedData === "true" && storedDataDate !== null) {

        const fechaActualTime = new Date();
        const fechaActualJustDate = new Date(fechaActualTime.getFullYear(), fechaActualTime.getMonth(), fechaActualTime.getDate(), 0, 0, 0);
        const fechaComparar = new Date(storedDataDate);
        if (storedDataDate !== null && fechaActualJustDate.getTime() > fechaComparar.getTime()) {
            var nuevaFecha =  SumarDiasFecha(fechaActualJustDate,1)
            AddLocalStorageElement(KEY_EXPIRE_MODAL_MARCACION_AVISO, nuevaFecha.toString());
            return true;

        }
        else if(storedDataDate !== null && fechaActualJustDate.getTime() <= fechaComparar.getTime()){
            return false
        }

        return false;
    }
    else{
        return false;
    }

}

export function CerrarLocalStorageMensajeMarcacion() {
    AddLocalStorageElement(KEY_SHOWMODAL_MARCACION_AVISO, "true");
    const fechaActualTime = new Date();
    const fechaActualJustDate = new Date(fechaActualTime.getFullYear(), fechaActualTime.getMonth(), fechaActualTime.getDate(), 0, 0, 0);
    var nuevaFecha =  SumarDiasFecha(fechaActualJustDate,1)
    AddLocalStorageElement(KEY_EXPIRE_MODAL_MARCACION_AVISO, nuevaFecha.toString());
}


export function CreateLocalStorageMensajeMarcacion() {


    AddLocalStorageElement(KEY_SHOWMODAL_MARCACION_AVISO, "false");

    const fechaActualTime = new Date();
    const fechaActualJustDate = new Date(fechaActualTime.getFullYear(), fechaActualTime.getMonth(), fechaActualTime.getDate(), 0, 0, 0);


    AddLocalStorageElement(KEY_EXPIRE_MODAL_MARCACION_AVISO, fechaActualJustDate.toString());


}

export function RemoveLocalStorageMensajeMarcacion() {
    for (let index = 0; index < ARRAY_LOCALSTORAGE_MODALMARCACIONES.length; index++) {
        var nombreStorage = ARRAY_LOCALSTORAGE_MODALMARCACIONES[index];
        localStorage.removeItem(nombreStorage);
    }
}




export function RemoveLocalStorageElements(keyslocalstorage: Array<string>) {

    for (let index = 0; index < keyslocalstorage.length; index++) {
        var nombreStorage = keyslocalstorage[index];
        localStorage.removeItem(nombreStorage);
    }
}

export function RemoveLocalStorageElementsModalActualizarDP() {
    for (let index = 0; index < ARRAY_LOCALSTORAGE_MODALACTUALIZARDP.length; index++) {
        var nombreStorage = ARRAY_LOCALSTORAGE_MODALACTUALIZARDP[index];
        localStorage.removeItem(nombreStorage);
    }
}
export function UpdateExpeditionTimeLocalStorage(nombreKey: string, cantidadDiasAgregar: number) {
    var fechaExpira = new Date()
    fechaExpira.setDate(fechaExpira.getDate() + cantidadDiasAgregar)
    localStorage.setItem(nombreKey, fechaExpira.toString());
}

